import { laptopRatio, mobileRatio, theme } from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const reassignClientModalStyle = {
  reassignClientModal: {
    '&.reassign-modal': {
      '& .modal-wrapper ': {
        width: getResponsiveSize(584), // 584px
      },
      '& .modal-header': {
        px: getResponsiveSize(24), // 24px
        pt: getResponsiveSize(29), // 29px
        pb: '0',
        border: 'none',
        justifyContent: 'center',
        '& .title': {
          color: theme.palette.neutral.black,
        },
      },
      '& .content': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        px: getResponsiveSize(24), // 24px
        py: getResponsiveSize(29), // 29px
        '& .content-item': {
          color: theme.palette.neutral.black,
          mb: getResponsiveSize(8.5), // 8.5px
          textAlign: 'center',
          ...theme.palette.propVars.regularFontWeight,
          '& span': {
            color: theme.palette.myPrimary.darkBlue100,
            ...theme.palette.propVars.semiBoldFontWeight,
          },
        },
        '& .MuiAutocomplete-root': {
          mt: getResponsiveSize(12),
          '&.loading': {
            '& .MuiCircularProgress-root': {
              position: 'absolute',
              color: theme.palette.myPrimary.lightBlue70,
              right: getResponsiveSize(28),
            },
            '& .MuiAutocomplete-endAdornment': {
              mr: getResponsiveSize(38),
              '& .MuiAutocomplete-popupIndicator': {
                display: 'none',
              },
            },
          },
        },
        '& .content-footer': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: getResponsiveSize(24), // 24px
          mt: getResponsiveSize(32), // 32px
          '& .main-btn': {
            width: getResponsiveSize(165), // 165px
            fontSize: theme.typography.fs16,
            border: 'none',
            ...theme.palette.propVars.regularFontWeight,
            '& .MuiCircularProgress-root': {
              width: `${getResponsiveSize(28)} !important`, // 28px
              height: `${getResponsiveSize(28)} !important`, // 28px
              color: theme.palette.neutral.white,
            },
          },
          '& .secondary-btn': {
            width: getResponsiveSize(165), // 165px
            fontSize: theme.typography.fs19,
            ...theme.palette.propVars.regularFontWeight,
          },
        },
      },
    },
    // Laptop screen
    [theme.breakpoints.media.laptop]: {
      '&.reassign-modal': {
        '& .modal-wrapper ': {
          width: getResponsiveSize(460, laptopRatio), // 460px
        },
        '& .modal-header': {
          px: getResponsiveSize(16, laptopRatio), // 16px
          pt: getResponsiveSize(20, laptopRatio), // 20px
        },
        '& .content': {
          '& .content-item': {
            mb: getResponsiveSize(8.5, laptopRatio),
          },
          '& .MuiAutocomplete-root': {
            mt: getResponsiveSize(14, laptopRatio),
          },
          '& .content-footer': {
            gap: getResponsiveSize(20, laptopRatio), // 20px
            mt: getResponsiveSize(25, laptopRatio),
            '& .main-btn': {
              width: getResponsiveSize(148, laptopRatio), // 148px
              height: getResponsiveSize(38, laptopRatio), // 38px
              fontSize: getResponsiveSize(14, laptopRatio), // 14px
              '& .MuiCircularProgress-root': {
                width: `${getResponsiveSize(24, laptopRatio)} !important`, // 24px
                height: `${getResponsiveSize(24, laptopRatio)} !important`, // 24px
              },
            },
            '& .secondary-btn': {
              width: getResponsiveSize(148, laptopRatio), // 148px
              height: getResponsiveSize(36, laptopRatio), // 36px
              fontSize: getResponsiveSize(14, laptopRatio), // 14px
            },
          },
        },
      },
    },
    // Table simple responsive screen
    [theme.breakpoints.media.tableResponsive]: {
      '&.reassign-modal': {
        '& .modal-wrapper ': {
          width: '80dvw',
          '& .modal-header': {
            px: getResponsiveSize(12, mobileRatio), // 12px
            pt: getResponsiveSize(20, mobileRatio), // 20px
            '& .title': {
              fontSize: getResponsiveSize(16, mobileRatio), // 16px
            },
          },
          '& .content': {
            '& .content-footer': {
              gap: getResponsiveSize(20, mobileRatio), // 20px
              mt: getResponsiveSize(20, mobileRatio), // 20px
              '& .main-btn': {
                width: getResponsiveSize(100, mobileRatio), // 100px
                height: getResponsiveSize(32, mobileRatio), // 32px
                fontSize: getResponsiveSize(14, mobileRatio), // 14px
                '& .MuiCircularProgress-root': {
                  width: `${getResponsiveSize(24, mobileRatio)} !important`, // 24px
                  height: `${getResponsiveSize(24, mobileRatio)} !important`, // 24px
                },
              },
              '& .secondary-btn': {
                width: getResponsiveSize(100, mobileRatio), // 100px
                height: getResponsiveSize(32, mobileRatio), // 32px
                fontSize: getResponsiveSize(14, mobileRatio), // 14px
              },
            },
          },
        },
      },
    },
  },
};
